module.exports = __webpack_public_path__ + "static/media/test-paper.877998d1.gif";